export enum Renewables {
  ALL_HYDRO = 'HYDRO',
  NON_PUMPED_STORAGE_HYDRO_PLANT = 'NPSHYD',
  PUMPED_STORAGE_HYDRO_PLANT = 'PS',
  SOLAR = 'SOLAR',
  WIND = 'WIND',
}
